class FacetFiltersForm extends HTMLElement {
  constructor() {
    super();
    // this.onActiveFilterClick = this.onActiveFilterClick.bind(this);
    console.log('FacetFiltersForm constructor', this.id);
    const facetWrapper = this.querySelector('#FacetsWrapperDesktop');
    if (facetWrapper) facetWrapper.addEventListener('keyup', onKeyUpEscape);

    const facetForm = this.querySelector('form');

    this.elementInput = this.elementInput.bind(this);
    facetForm.addEventListener('input', this.elementInput);

    this.elementClick = this.elementClick.bind(this);
    facetForm.addEventListener('click', this.elementClick);
  }

  elementInput(e) {
    const target = e.srcElement || e.target;
    const closest = target.closest('#FacetFiltersForm');
    const btnApplyFilters = closest && closest.length > 0 ? target.closest('#FacetFiltersForm').getElementsByClassName('btn_apply_filters') : undefined;
    if (btnApplyFilters == undefined || btnApplyFilters.length == 0) {
      // console.log('addEventListener input CAN SUBMIT');
      this.onSubmitHandler(e);
    } else {
      // console.log('addEventListener input NO SUBMIT');
    }
  }
  elementClick(e) {
    const target = e.srcElement || e.target;
    if (target.classList.contains('btn_apply_filters')) {
      // console.log('addEventListener btn_apply_filters CAN SUBMIT');
      this.onSubmitHandler(e);
    }
  }

  // static toggleActiveFacets(disable = true) {
  //   document.querySelectorAll('.js-facet-remove').forEach((element) => {
  //     element.classList.toggle('disabled', disable);
  //   });
  // }

  static updateURLHash(searchParams) {
    history.pushState({ searchParams }, '', `${window.location.pathname}${searchParams && '?'.concat(searchParams)}`);
  }

  static getSections() {
    return [
      {
        section: document.getElementById('product-grid').dataset.id,
      },
    ];
  }

  createSearchParams(form) {
    const formData = new FormData(form);
    return new URLSearchParams(formData).toString();
  }

  onSubmitForm(searchParams, event) {
    // console.log(searchParams);
    const tabFiltresPush = {};
    const tabOrderPush = {};
    const tabSplitAnd = `${searchParams}`.split("&");
    for (let i = 0; i < tabSplitAnd.length; i++) {
      const v = `${tabSplitAnd[i]}`.trim();
      if(v != "") {
        const tabSplitKeyValeur = `${v}`.split("=");
        if (tabSplitKeyValeur.length == 2) {
          const key = `${tabSplitKeyValeur[0]}`.trim();
          const value = `${tabSplitKeyValeur[1]}`.trim();
          switch (key) {
            case "q":
            case "options%5Bprefix%5D":
              // on passe
              break;
            case "sort_by":
              tabOrderPush.order_by = value.split("-")[0]; // pertinence, prix, popularite, nouveaute, alphabetique
              tabOrderPush.order_by_sens = value.split("-")[1]; // asc, desc
              break;
            default:
              if (tabFiltresPush[key] == undefined) {
                tabFiltresPush[key] = [];
              }
              tabFiltresPush[key].push(value);
              break;
          }            
        }
      }
    }
    preProcessFilter(tabFiltresPush, tabOrderPush);
  }

  onSubmitHandler(event) {
    event.preventDefault();
    const sortFilterForms = document.querySelectorAll('facet-filters-form form');
    if (event.srcElement.className == 'mobile-facets__checkbox') {
      const searchParams = this.createSearchParams(event.target.closest('form'));
      this.onSubmitForm(searchParams, event);
    } else {
      const forms = [];
      const isMobile = event.target.closest('form').id === 'FacetFiltersFormMobile';

      sortFilterForms.forEach((form) => {
        if (!isMobile) {
          if (form.id === 'FacetSortForm' || form.id === 'FacetFiltersForm' || form.id === 'FacetSortDrawerForm') {
            const noJsElements = document.querySelectorAll('.no-js-list');
            noJsElements.forEach((el) => el.remove());
            forms.push(this.createSearchParams(form));
          }
        } else if (form.id === 'FacetFiltersFormMobile') {
          forms.push(this.createSearchParams(form));
        }
      });
      this.onSubmitForm(forms.join('&'), event);
      // this.onSubmitForm(forms, event);
    }
  }
  /*
  onActiveFilterClick(event) {
    event.preventDefault();
    FacetFiltersForm.toggleActiveFacets();
    const url =
      event.currentTarget.href.indexOf('?') == -1
        ? ''
        : event.currentTarget.href.slice(event.currentTarget.href.indexOf('?') + 1);
    FacetFiltersForm.renderPage(url);
  }*/
}

FacetFiltersForm.filterData = [];
FacetFiltersForm.searchParamsInitial = window.location.search.slice(1);
FacetFiltersForm.searchParamsPrev = window.location.search.slice(1);
customElements.define('facet-filters-form', FacetFiltersForm);
